import React, {forwardRef} from "react";

export function MenuWrapper({ children }: { children?: React.ReactNode }) {
  return (
    <div className="d-flex mt-2 me-4">
      <div className="flex-grow-1 d-flex ms-3 align-items-center">
        {children}
      </div>
    </div>
  )
}

export function MenuSection({ children }: { children?: React.ReactNode }) {
  return (
    <div className="d-flex align-content-center mx-2">
      {children}
    </div>
  );
}

export function MenuLabel({ children }: { children?: React.ReactNode }) {
  return (
    <label className="col-auto d-flex align-items-center my-1 mx-2" style={{ textAlign: "center" }}>{children}</label>
  );
}

interface MenuInputProps extends React.ComponentPropsWithoutRef<'input'> {}

export const MenuInput = forwardRef<HTMLInputElement, MenuInputProps>((props, ref) => (
  <input {...props} ref={ref} className={"form-control " + props.className}/>
));